import {
  adminRoutes,
  archiviPartecipateRoutes,
  archiviRoutes,
  bilancioConsolidatoPartecipoRoutes,
  gestioneCepRoutes,
  gestioneEnteRoutes,
  gestionePartecipateRoutes,
  utilityCepRoutes,
  utilityPartecipoRoutes,
} from '../../routes';
import { MenuItem } from './menu.model';

const CONDIVISO_MENU: MenuItem[] = [
  {
    label: 'Condiviso',
    isTitle: true,
    modulo: undefined,
    subItems: [
      {
        label: 'Amministrazione',
        isTitle: true,
        modulo: undefined,
        subItems: [
          ...adminRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: undefined,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
      {
        label: 'Archivi generali',
        isTitle: true,
        modulo: undefined,
        subItems: [
          ...archiviRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: undefined,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
    ],
  },
];

const PARTECIPO_MENU: MenuItem[] = [
  {
    label: 'Consolid@to',
    isTitle: true,
    modulo: 'partecipo',
    subItems: [
      {
        label: 'Gestione partecipate',
        isTitle: true,
        modulo: 'partecipo',
        subItems: [
          ...gestionePartecipateRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: item.modulo,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
      {
        label: 'Bilancio Consolidato',
        isTitle: true,
        modulo: 'partecipo',
        subItems: [
          ...bilancioConsolidatoPartecipoRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: item.modulo,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
      {
        label: 'Utility',
        isTitle: true,
        modulo: 'partecipo',
        subItems: [
          ...utilityPartecipoRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: item.modulo,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
      {
        label: 'Archivi generali',
        isTitle: true,
        modulo: 'partecipo',
        subItems: [
          ...archiviPartecipateRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: item.modulo,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
    ],
  },
];

const CEP_MENU: MenuItem[] = [
  {
    label: 'CEP',
    isTitle: true,
    modulo: 'cep',
    subItems: [
      {
        label: 'Gestione CEP',
        isTitle: true,
        modulo: 'cep',
        subItems: [
          ...gestioneCepRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: item.modulo,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
      {
        label: 'Gestione Ente',
        isTitle: true,
        modulo: 'cep',
        subItems: [
          ...gestioneEnteRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: item.modulo,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
      {
        label: 'Utility',
        isTitle: true,
        modulo: 'cep',
        subItems: [
          ...utilityCepRoutes
            .filter((item) => !item.menuHidden)
            .map((item) => {
              const menuItem: MenuItem = {
                label: item.label,
                link: item.path,
                modulo: item.modulo,
                permissions: item.permissions,
              };
              return menuItem;
            }),
        ],
      },
    ],
  },
];

export const MENU: MenuItem[] = [
  // {
  //   label: 'Main',
  //   isTitle: true,
  // },
  {
    label: 'Dashboard',
    //icon: 'home',
    link: 'home',
  },
  {
    label: 'Notifiche',
    //icon: 'home',
    link: 'notifica',
  },
  ...CONDIVISO_MENU,
  ...PARTECIPO_MENU,
  ...CEP_MENU,
];
